import { render, staticRenderFns } from "./Requisition.vue?vue&type=template&id=612b2c74&scoped=true"
import script from "./Requisition.vue?vue&type=script&lang=js"
export * from "./Requisition.vue?vue&type=script&lang=js"
import style0 from "./Requisition.vue?vue&type=style&index=0&id=612b2c74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612b2c74",
  null
  
)

export default component.exports